import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import MainLayout from './components/Layout/MainLayout';
import { App as AntApp } from 'antd';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SettingsPage from './pages/Settings/SettingsPage';
import { AuthProvider } from './components/Auth/context/AuthContext';
import PrivateRoute from './components/Auth/route/PrivateRoute';
import ProtectedRoute from './components/Auth/route/ProtectedRoute';
import { ROUTES } from './utils/constants';
import RoleFieldAssignmentPage from './pages/RoleFieldAssignment/RoleFieldAssignmentPage';
import AddRoleFieldAssignment from './pages/RoleFieldAssignment/AddRoleFieldAssignment';
import UserSignup from './pages/RoleFieldAssignment/UserSignup';
import DashboardPage from "./pages/Dashboard/DashboardPage";
import LoginPage from "./pages/Login/LoginPage";
import FileUploadPage from "./pages/FileUploader/FileUploadPage";
import CompanyEnrichPage from "./pages/Leads/CompanyEnrichPage";
import EmployeeEnrichPage from "./pages/Leads/EmployeeEnrichPage";
import B2BDataOperationPage from "./pages/ReloadPage/B2BDataOperationPage";
import DatabaseConsolePage from "./pages/DbQueries/DatabaseConsolePage";


function App() {
  return (
    <AntApp>
      <ToastContainer />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
              <Route path={ROUTES.LOGIN} element={<LoginPage />} />
            <Route
              path="/" element={
                <PrivateRoute>
                  <MainLayout />
                </PrivateRoute>} >



                <Route
                    path={ROUTES.FILE_UPLOAD}
                    element={
                        <ProtectedRoute requiredPermission={ROUTES.FILE_UPLOAD}>
                            <FileUploadPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={ROUTES.COMPANY_ENRICH_PAGE}
                    element={
                        <ProtectedRoute requiredPermission={ROUTES.COMPANY_ENRICH_PAGE}>
                            <CompanyEnrichPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={ROUTES.EMPLOYEE_ENRICH_PAGE}
                    element={
                        <ProtectedRoute requiredPermission={ROUTES.EMPLOYEE_ENRICH_PAGE}>
                            <EmployeeEnrichPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={ROUTES.B2BDataOperations}
                    element={
                        <ProtectedRoute requiredPermission={ROUTES.B2BDataOperations}>
                            <B2BDataOperationPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={ROUTES.DB_CONSOLE}
                    element={
                        <ProtectedRoute requiredPermission={ROUTES.DB_CONSOLE}>
                            <DatabaseConsolePage />
                        </ProtectedRoute>
                    }
                />

              <Route path={ROUTES.SETTINGS} element=
                {<ProtectedRoute requiredPermission={ROUTES.SETTINGS}>
                  <SettingsPage />
                </ProtectedRoute>} />
              <Route path={ROUTES.ROLE_FIELD_ASSIGNMENTS} element=
                {<ProtectedRoute requiredPermission={ROUTES.ROLE_FIELD_ASSIGNMENTS}>
                  <RoleFieldAssignmentPage />
                </ProtectedRoute>} />
              <Route path={ROUTES.ADD_ROLE_FIELD_ASSIGNMENT} element=
                {<ProtectedRoute requiredPermission={ROUTES.ADD_ROLE_FIELD_ASSIGNMENT}>
                  <AddRoleFieldAssignment />
                </ProtectedRoute>} />
              <Route path={ROUTES.USER_SIGN_UP} element=
                {<ProtectedRoute requiredPermission={ROUTES.USER_SIGN_UP}>
                  <UserSignup />
                </ProtectedRoute>} />
              <Route path={ROUTES.DASHBOARD} element={<DashboardPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </AntApp>
  );
}

export default App;
